<script>
export default {
    name: "ConfirmCancelLPO",
data(){
  return {
 cancellpodata:{
  lpoNo:"",
  userName:this.$root.username,
  comment:"Cancel Unposted LPO",

}
  }
},
    props: {
        lpoNo: String,
        showModal: {
            type: Boolean,
            default: false
        }
    },

  
    methods: {

       CancellpoNo() {

            this.$root.loading = true;
this.cancellpodata.lpoNo=this.lpoNo;
            this.$accountsHttp.post('SupplierLPO/CancelSupplierLpo',this.cancellpodata)
              .then(response => {
                this.$root.loading = false;
               this.$emit(`closeModal`, true);
                window.Swal.fire({ text: response.data, type: 'success' });
             
            }).catch(() => this.$root.loading = false);
      },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 w-1/2">
      <template v-slot:title>
        <h5 class="font-semibold text-sm">Confirm Cancel LPO</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-4">
          <h4 class="font-bold text-sm text-blue text-center">LPO No: {{ lpoNo  }}</h4>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-8" @click="$emit(`closeModal`)">Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="CancellpoNo">
            <i class="fa fa-check"></i> Confirm Cancel LPO
            </button>
      </template>
    </tail-modal>
</template>
